module.exports = __webpack_public_path__ + "static/img/21.16062c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/21.png
// module id = Sr60
// module chunks = 0